const $forms = $('.form-embed-form');

const setupPrefilledFields = () => {
  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const schedule = urlParams.get('Schedule')
    const scheduleField = document.querySelector('input[name="i_am_interested_in_scheduling_a_demo_"]')

    if (schedule && scheduleField) {
      scheduleField.checked = true
    }
  }, 500)
}

export default {
    can: () => $forms.length,
    run: () => {
      setupPrefilledFields()
    },
};
